import { Directive, DoCheck, ElementRef, Renderer2, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * ngx-mask (v21) has a constructor effect that calls `setDisabledState(this.disabled())`
 * with its `disabled` input defaulting to `false`. For a masked input created while its
 * reactive form control is already disabled, that effect re-enables the native input,
 * leaving it editable even though the form control is disabled.
 *
 * This directive re-asserts the native `disabled` property from the bound form control,
 * keeping masked inputs in sync with reactive-forms disabled state.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'input[mask]',
  standalone: false,
})
export class MaskDisabledSyncDirective implements DoCheck {
  private readonly el = inject<ElementRef<HTMLInputElement>>(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly ngControl = inject(NgControl, { optional: true });

  public ngDoCheck(): void {
    const control = this.ngControl?.control;
    if (!control) {
      return;
    }

    const input = this.el.nativeElement;
    if (input.disabled !== control.disabled) {
      this.renderer.setProperty(input, 'disabled', control.disabled);
    }
  }
}
